




































import { Component, Vue } from "vue-property-decorator";
import Sidebar from "../components/Sidebar.vue";
import { store, StoreState } from "../store";
import { mapState } from "vuex";
import VueElementLoading from "vue-element-loading";
import { RotateSquare2 } from "vue-loading-spinner";

@Component({
  components: {
    Sidebar,
    RotateSquare2,
    VueElementLoading
  },
  computed: {    
      ...mapState({
        alert_loader: (state: StoreState) => state.dashboard.admin.admin_loader,
        'notifications': (state: StoreState) => state.dashboard.notifications,
        'selectedContact': (state: StoreState) => state.dashboard.selectedContact,
        'contacts': (state: StoreState) =>state.dashboard.contacts
    })
  },
   mounted: function() {
        this.$data.notinction_loader=true
       // this.notifn_created();
      },
})
export default class NotificationModal extends Vue {
  data() {
    return {
      org_alerts: [],
      alerts: [],
      notinction_loader:false,
      isalertnotification:false,
      activetab:""
    };
  }

  Get_incomingnotifications(){
      return (this as any).notifications.filter(function(e){return e.direction=='in'}); 
       //return (this as any).notifications; 
    } 
		



		 
		readNotification(notification)
		{
      var n=(this as any).$route.path!== "/TextingPanel";
      if(n){
        this.$router.push({ name: 'TextingPanel' });
        
        var self=this;
         setTimeout(function(){
                self.$store.commit('SET_NOTIFICATION_NOTIFICATIONMODAL' ,notification);
            }, 1000);
      }
      else{
        this.$store.commit('SET_NOTIFICATION_NOTIFICATIONMODAL' ,notification);
        
      }
		}

    Open_textchain(notification){
       this.$store.commit('SET_NOTIFICATION_BADGE' ,false);    
    if(notification.contact) {
        if ( !notification.contact.numbers)
        {
        notification.contact.numbers = {
            mobile: { number: notification.contact.first_name
                },
            main:[notification.contact.first_name]
        }
        notification.contact.address= {};
        notification.name=  notification.contact.first_name;
        notification.contact.hideEdit=true;
       }
       this.$store.commit('SET_START_NEWTEXT',false);
       this.$store.commit('SET_TEXTPNL_CONTACTINFO','Message_list');
       
        this.$store.commit('CHANGE_SELECTED_CONTACT', notification.contact);
            this.$data.fullname=`${(this as any).selectedContact.first_name} ${(this as any).selectedContact.last_name}`;
            this.$emit('notification', notification.socketRoom); 
            this.$store.commit("SHOW_CONTACT_DETAIL", true);
            if (notification.eventType=='vm')
            {
            this.$store.commit("SET_CONTACT_STATUS_VM", true);
            this.$store.commit("SET_NOTIFICATION_VM_ID", notification.id);
            this.$store.commit("SET_NOTIFICATION_VOICE", notification);
            }
            else{
            this.$store.commit('SET_FOCUSTEXT', notification.timetofocus_ontext);
            this.$store.dispatch('markNotificationAsRead', notification);
            this.$store.commit('DELETE_NOTIFICATION', {notificationId: notification.id});
            }
        this.$store.commit('SET_NUMBER_BEING_CALLED', notification.socketRoom);
        this.$data.notifications_open = true;
        let conta = JSON.stringify(notification.contact);           
        this.$store.commit("CHANGE_NOTIFICATION_CONTACT", conta);
        this.$store.commit("SET_TEXTMESSAGETAB",this.$data.activetab)
        }
    }

}
